import React, { useState } from 'react'
import { FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material'
import { Control, Controller, UseFormRegister } from 'react-hook-form'

import { format } from 'date-fns'
import { ErrorMessage, FormInput } from '../../../../components/styled/uiComponents'

interface Props {
  register: UseFormRegister<any>
  control: Control<any, any>
  getValues: (name?: string) => any
  errors: any
  metaData?: any
}

const TemporaryExpat: React.FC<Props> = ({ register, control, errors }) => {
  const [startDate, setStartDate] = useState<string>('')
  const [endDate, setEndDate] = useState<string>('')

  const handleChangeStartDate = (e: any) => {
    setStartDate(e.target.value)
  }

  const handleChangeEndDate = (e: any) => {
    setEndDate(e.target.value)
  }

  const thisYear = () => {
    return new Date().getFullYear()
  }

  const today = format(new Date(), 'yyyy-MM-d')

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Grid item xs={12}>
          <Typography variant='h4' color='primary'>
            Oleskelu ulkomailla, tilapäinen
          </Typography>
          <p>
            Yhtäjaksoisesti vähintään vuoden ulkomailla oleskeleva, ei tee lääkärin työtä Suomessa.
            Alennus -50 % perusjäsenmaksusta, myönnetään toistaiseksi.
          </p>
        </Grid>

        <Grid item xs={12}>
          <Controller
            name='els_alennusvuosi'
            control={control}
            defaultValue={thisYear()}
            render={({ field: { onChange, value } }) => (
              <RadioGroup onChange={e => onChange(e.target.value)} value={value}>
                <FormControlLabel
                  value={thisYear()}
                  control={<Radio />}
                  label={`Haen alennusta tälle vuodelle (${thisYear()})`}
                />
                <FormControlLabel
                  value={thisYear() + 1}
                  control={<Radio />}
                  label={`Haen alennusta ensi vuodelle (${thisYear() + 1})`}
                />
              </RadioGroup>
            )}
          />
          <ErrorMessage>{errors?.els_alennusvuosi?.message}</ErrorMessage>
        </Grid>

        <div style={{ borderTop: '1px dotted black', paddingTop: '3vh' }}>
          <Grid item xs={12} md={6}>
            <Typography variant='h6' color='primary'>
              Jäsenmaksun mahdollinen palautus
            </Typography>
            <FormLabel>
              Tilinumero jäsenmaksun mahdollista palautusta varten (IBAN-muodossa)
            </FormLabel>
            <FormInput {...register('bankAccount')} />
            <ErrorMessage>{errors?.bankAccount?.message}</ErrorMessage>
          </Grid>
        </div>
      </Grid>
    </Grid>
  )
}

export default TemporaryExpat
